import React from 'react';
import { Share1Icon} from "@radix-ui/react-icons";
import { copyToClipboard } from "../utils/copyToClipboard";

const primary = '#8d3939ff';

type PopUpMsgProps = {
    title: string;
    description: string;
    onClose: () => void;
    url : string;
};

const PopUpShare: React.FC<PopUpMsgProps> = ({
    title,
    description,
    onClose,
    url
}) => {

    const [copied, setCopied] = React.useState(false);

    const handleCopy = async () => {
        const ok = await copyToClipboard(url);
        setCopied(ok);
        if (ok) setTimeout(() => setCopied(false), 2000);
    };

    const handleShare = async () => {
        if ((navigator as any).share) {
            try {
                await (navigator as any).share({
                    title,
                    text: description,
                    url
                });
            } catch (err) {
                // user cancelled or share failed
            }
        } else {
            await handleCopy();
        }
    };
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }} role="dialog" aria-modal="true">
            <div style={{
                background: '#f9f9f9', width: 560, maxWidth: '96%', borderRadius: 12, display: 'flex', flexDirection: 'column',
                boxShadow: '0 14px 40px rgba(13,21,28,0.24)', overflow: 'hidden', fontFamily: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial'
            }}>
                <div style={{ padding: 20, borderBottom: '1px solid #f3f3f3' }}>
                    <div style={{ fontSize: 18, fontWeight: 600, color: '#222' }}>{title}</div>
                    <div style={{ marginTop: 8, color: '#555', fontSize: 14, whiteSpace: 'pre-wrap' }}>{description.replace(/\\n/g, '\n')}</div>
                </div>

                <div style={{ padding: 16, display: 'flex', gap: 12, alignItems: 'center', background: '#fff', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
                        <input
                            aria-label="Share link"
                            value={url}
                            readOnly
                            onFocus={(e) => (e.currentTarget as HTMLInputElement).select()}
                            style={{ flex: 1, minWidth: 0, padding: '8px 10px', border: '1px solid #e6e6e6', borderRadius: 8, fontSize: 14 }}
                        />
                        <button onClick={handleCopy} aria-label="Copy link" title="Copy link" style={{ background: primary, color: '#fff', border: 'none', padding: '8px 10px', borderRadius: 8, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                            {copied ? 'Copied' : 'Copy'}
                        </button>
                        <button onClick={handleShare} aria-label="Share" title="Share" style={{ background: '#fff', color: primary, border: '1px solid #eee', padding: '8px', borderRadius: 8, cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                            <Share1Icon />
                        </button>
                    </div>
                </div>

                <div style={{ padding: 16, display: 'flex', justifyContent: 'flex-end', gap: 12, background: '#fff' }}>
                    <button onClick={onClose} style={{ background: 'transparent', color: '#666', border: '1px solid #e9e9e9', padding: '8px 12px', borderRadius: 8, cursor: 'pointer' }}>Close</button>                    
                </div>
            </div>
        </div>
    );
};

export default PopUpShare;

